import React from 'react';
import SalesPage from './pages/sales';
import CallCenterPage from './pages/call-center';

const App: React.FC = () => {
  const path = window.location.pathname;

  if (path === '/pages/call-center' || path === '/call-center') {
    return (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <CallCenterPage />
      </div>
    );
  }

  if (path === '/pages/sales' || path === '/sales' || path === '/') {
    return (
      <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
        <SalesPage />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden">
      <SalesPage />
    </div>
  );
};

export default App;
